/* SLIDE 34 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSpots, fetchAllParkingSpots, fetchAllParkingSpotTypes } from "features/parking/presentation/store/parkingSlice";
import SubHeader from "shared/components/SubHeader";
import ButtonBot from "shared/components/ButtonBot";
const ParkingWorkdayAttendancePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(fetchAllParkingSpots());
    dispatch(fetchAllParkingSpotTypes());

  }, [dispatch]);

  const handleCancel = () => {
    navigate("/parking_setting_manager");
  };
  const handleAdd = () => {
    // alert("successfully!");
    console.log("successfully!")
  };
  return (
    <div className={`parking-status-container parking-attendance-container`}>
      <SubHeader>
        <div className={`sub-header-text w-full`} >
          <span className="htColorGray2">주차장명 : </span>
          <span className="htBold">새마을시장(01-002)</span>
        </div>

      </SubHeader>
      <div className="htContent">
        <div className="mn-header-attendance">
          <div className="mn-content-attendance">
            <div className="flex justify-between mn-text-content">
              <span>근무장소</span>
              <span className="mn-text-content-right">152가 2045</span>
            </div>

            <div className="flex justify-between mn-text-content">
              <span>출근시각</span>
              <span className="mn-text-content-right">2024-11-20 13:15</span>
            </div>

            <div>
              <div className="mn-text-content" style={{ paddingBottom: "10px" }}>출근메모</div>
              <textarea className="mn-textarea p-2" rows="3" />
            </div>

            <div className="flex justify-between mn-text-content" style={{ marginTop: "13px" }}>
              <span>퇴근시각</span>
              <span className="mn-text-content-right">2024-11-20 13:15</span>
            </div>

            <div>
              <div className="mn-text-content" style={{ paddingBottom: "10px" }}>퇴근메모</div>
              <textarea className="p-2 mn-textarea" rows="3" defaultValue="정상퇴근하였습니다." />
            </div>

            <div className="flex justify-end" style={{paddingBottom: "40px"}}>
              <button className="mn-button-attendance">
                정상근무
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between mn-text-bottom-attendance" style={{padding: "20px"}}>
        <span>일 근무시간</span>
        <span style={{ color: "#222222", fontWeight: "700", fontSize: "15px" }}>8시간</span>
      </div>
      {/* <div className="button-bot">
        <button className="delete-button" onClick={handleCancel}>
          삭제하기
        </button>
        <button className="add-button" onClick={handleAdd}>
          수정하기
        </button>
      </div> */}
      <ButtonBot
        textYes={"수정하기"}
        handleYes={handleAdd}
        textNo={"삭제하기"}
        handleNo={handleCancel}
      />

    </div>
  );
};

export default ParkingWorkdayAttendancePage;
